export default __webpack_public_path__ + "media/transfer_window/transfer_completed-3-7c3db577.gif";